export default __webpack_public_path__ + "static/media/button__ellipsis-horizontal.d00358c0.svg";